import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GetContainersByShippingAgentParams } from '../../../global/adapters/crpAPI';
import StepUseCase from '../../../global/components/Stepper/StepUseCase';
import { ShippingAgentSearchStep } from '../shared';
import { FormikErrors } from 'formik';
import { useGetActiveShippingAgents } from 'modules/release-party/adapters/search-containers/queries';
import { LABEL } from 'theme/constants';

type Props = {
  isFetching?: boolean;
  resetForm: VoidFunction;
  submitForm: VoidFunction;
  values: GetContainersByShippingAgentParams;
  errors: FormikErrors<GetContainersByShippingAgentParams>;
  onResetSearch: VoidFunction;
};

const StepperSearchContainers = ({
  isFetching,
  resetForm,
  submitForm,
  values,
  errors,
  onResetSearch,
}: Props) => {
  const { t } = useTranslation(['common', 'useCase', 'validation']);

  const resetFormAndValues = () => {
    resetForm();
    onResetSearch();
  };

  const {
    data: shippingAgents,
    isFetching: isFetchingAgents,
    isError: isErrorAgents,
  } = useGetActiveShippingAgents();

  const equipmentNumberError = Boolean(errors.equipmentNumber);
  const shippingAgentNxtEntityIdError = Boolean(errors.shippingAgentNxtEntityId);
  const billOfLadingNumberError = Boolean(errors.billOfLadingNumber);

  const hasValidationError =
    equipmentNumberError || shippingAgentNxtEntityIdError || billOfLadingNumberError;

  const { shippingAgentNxtEntityId, equipmentNumber, billOfLadingNumber } = values;
  const searchAvailable =
    Boolean(shippingAgentNxtEntityId && shippingAgentNxtEntityId !== LABEL.UNKNOWN) ||
    Boolean(equipmentNumber) ||
    Boolean(billOfLadingNumber);

  return (
    <Paper sx={{ p: 2, minWidth: 0, overflow: 'visible' }}>
      <StepUseCase
        activeStep={0}
        steps={[
          {
            stepTitle: t('common:general.search'),
            stepFlavorText: t('useCase:containers.searchContainersFlavorText'),
            backCallBack: resetFormAndValues,
            backCustomText: t('common:general.reset'),
            nextCallBack: submitForm,
            nextCustomText: isFetching
              ? t('useCase:containers.loadingContainers')
              : t('useCase:containers.searchContainers'),
            nextIsLoading: isFetching,
            content: (
              <ShippingAgentSearchStep
                shippingAgents={shippingAgents}
                hasValidationError={hasValidationError}
                validationMessage={t('validation:allFields')}
                isFetching={isFetchingAgents}
                isError={isErrorAgents}
                showIsArchivedToggle={true}
              />
            ),
            disableNext: !searchAvailable,
          },
        ]}
      />
    </Paper>
  );
};
export default StepperSearchContainers;
